import { Box, Button, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import AddFile from '../Organization/AddFile'
import { StartNewFileIcon } from '../Svgs'

interface StartNewFileInProjectProps {}

const StartNewFileInProjectComponent: React.FC<
  StartNewFileInProjectProps
> = ({}) => {
  const dispatch = useDispatch<any>()
  const [isAddFileDialogOpen, setIsAddFileDialogOpen] = useState(false)

  return (
    <>
      <Button
        disableRipple
        onClick={() => setIsAddFileDialogOpen(true)}
        sx={{
          background: '#E5F0FF',
          borderRadius: '0.4rem',
          width: '100%',
          height: '100%',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          boxSizing: 'border-box',
          gap: '1rem',
          p: '0.75rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            borderRadius: '0.4rem',
            boxShadow: '0px 1px 5px 0px #00000040',
            background: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 'normal',
            gap: '1.5rem',
          }}
        >
          <StartNewFileIcon color={'#1705E5'} />
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.82rem',
              color: '#04002E',
              textTransform: 'none',
            }}
          >
            Start a New File
          </Typography>
        </Box>
      </Button>
      <AddFile
        isOpen={isAddFileDialogOpen}
        disableClientDropdown={true}
        disableProjectDropdown={true}
        handleClose={() => setIsAddFileDialogOpen(false)}
      />
    </>
  )
}

export default StartNewFileInProjectComponent
